'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var index = require('../../index-7124f64c.js');

var refType = index.propTypes.oneOfType([index.propTypes.func, index.propTypes.object]);

exports.default = refType;
//# sourceMappingURL=refType.js.map
